module.exports = __webpack_public_path__ + "img/Symbol on transparent background.f349657b.png";